import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Box } from '@gemini/core';
const BoxLinkHoverable = ({ letter, disabled = false }) => {
    const [color, setColor] = useState(disabled ? 'color.content.disabled' : 'color.content.default.default');
    return (_jsx(Box, { as: "a", href: disabled ? '#' : `#${letter}`, onPointerEnter: disabled ? undefined : () => setColor('color.content.disabled'), onPointerLeave: disabled ? undefined : () => setColor('color.content.default.default'), typography: "typography.body.14.bold", color: color, children: letter }));
};
export default BoxLinkHoverable;
